import React from 'react';
import { Compass, MapPin } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { ClosestCarousel } from './ClosestCarousel';
import { EventsCarousel } from './EventsCarousel';
import { SkeletonVenueList } from './SkeletonVenueList';
import { MapEmptyState } from './MapEmptyState';

/**
 * Virtualized-list header row for the Guest Map — the "Closest to
 * you" carousel, the "Happening this week" events strip, the "All
 * around you" heading, and the empty-state prompt when appropriate.
 *
 * IMPORTANT: Closest + Events are always rendered (when they have
 * data) regardless of the map viewport. Previously they were nested
 * inside the `sortedVenues.length === 0` branch which caused the
 * whole header — and therefore the events carousel — to disappear
 * whenever the map was zoomed tight enough that no venues fell
 * inside its bounds. Keep that invariant here.
 */
export function GuestMapListHeader({
  loading,
  featuredVenues,
  userPosition,
  onFeaturedVenueClick,
  nearbyEvents,
  onEventVenueTap,
  sortedVenuesCount,
  locationStatus,
  onRequestLocation,
}) {
  if (loading) return <SkeletonVenueList />;

  return (
    <>
      {featuredVenues.length > 0 ? (
        <>
          <SectionHeading
            icon={<Compass size={14} strokeWidth={2.4} />}
            title="Closest to you"
            count={featuredVenues.length}
          />
          <ClosestCarousel
            venues={featuredVenues}
            userPosition={userPosition}
            onVenueClick={onFeaturedVenueClick}
          />
        </>
      ) : null}

      <EventsCarousel events={nearbyEvents} onVenueClick={onEventVenueTap} />

      <SectionHeading
        icon={<MapPin size={14} strokeWidth={2.4} />}
        title="All around you"
        count={sortedVenuesCount}
      />

      {sortedVenuesCount === 0 ? (
        <MapEmptyState
          locationStatus={locationStatus}
          onRequestLocation={onRequestLocation}
        />
      ) : null}
    </>
  );
}
